import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "src/store/features/auth/axiosCSRF";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";



export interface iResetPasswordResetRequestState {
    response : any | null;
    isLoading : boolean;
    message : string | null;
}

const initialState : iResetPasswordResetRequestState = {
    response : null,
    isLoading : false,
    message : null,
}

export const postPasswordResetRequest = createAsyncThunk(
    "POST_PASSWORD_REST_REQUEST",
    async (params:{email:string}, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/auth/password-reset/request/';
            const response = await axiosInstance.post(`${djangoEndpoint}${pathParam}`, {
                email : params.email
            },
        {
            withCredentials : true,
        });
            return response.data;
        } catch (e) {
            console.error('User My Held Balance API 에러:', e);
            return rejectWithValue(e.response ? e.response.data : e.message);
        }
    }
)

export const postPasswordResetRequestSlice = createSlice({
    name : "postPasswordResetRequest",
    initialState,
    reducers : {},
    extraReducers : (builder) => {
        builder
        .addCase(postPasswordResetRequest.pending, (state) => {
            state.isLoading = true;
            state.message = null;
        })
        .addCase(postPasswordResetRequest.fulfilled, (state, action) => {
            state.isLoading = false;
            state.response = action.payload;
        })
        .addCase(postPasswordResetRequest.rejected, (state, action) => {
            state.isLoading = false;
            state.message = action.payload as string;
        })
    }
})


export default postPasswordResetRequestSlice.reducer;